export default function DropdownItem(props) {
  return (
    <button className='dropdown-item button is-shadowless is-radiusless' onClick={() => props.select(props.text)} >
      {props.text}
    </button>
  )
}